import React from 'react';
import { mergeClasses, ProgressBar, Text } from '@fluentui/react-components';
import { useMilestoneProgressBarStyles } from './MilestoneProgressBar.styles';

interface MilestoneProgressBarProps {
  currentProgress: number
  milestones: number[]
  text?: string
  className?: string
}

const MilestoneProgressBar: React.FC<MilestoneProgressBarProps> = ({
  currentProgress,
  milestones,
  text,
  className,
}) => {
  const styles = useMilestoneProgressBarStyles();
  const validProgress = Math.min(Math.max(currentProgress ?? 0, 0), 100);
  const renderMilestones = (): JSX.Element[] => {
    return milestones.map((milestone) => {
      const isCompleted = validProgress >= milestone;
      const progressMileStoneTestId = isCompleted ? `completed-${milestone}` : `incomplete-${milestone}`;
      return (
        <div
          data-testid={`milestone-point-${milestone}`}
          key={milestone}
          className={mergeClasses('milestone-item', styles.milestoneItem)}
          style={{ left: `${milestone}%` }}
        >
          <div
            data-testid={progressMileStoneTestId}
            className={mergeClasses(
              styles.milestoneDot,
              isCompleted && styles.milestoneDotCompleted,
            )}
          />
        </div>
      );
    });
  };

  return (
    <div className={mergeClasses(styles.container, className)} data-testid="milestone-progress-bar">
      <div className={styles.progressWrapper}>
        <ProgressBar
          value={validProgress}
          max={100}
          shape="rounded"
          thickness="large"
          className={styles.progressBar}
        />
        <div data-testid="milestone-row">
          {renderMilestones()}
        </div>
      </div>
      {text && <Text data-testid="text">{text}</Text>}
    </div>
  );
};

export default MilestoneProgressBar;
